export default __webpack_public_path__ + "static/media/551.6726958b.gif";